/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Previous_MetaInputs */



/**
* | output |
* | --- |
* | "report" |
*
* @param {Meeting_Sources_Previous_MetaInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_previous_meta = /** @type {((inputs?: Meeting_Sources_Previous_MetaInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Previous_MetaInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("compte rendu")
	return /** @type {LocalizedString} */ ("report")
});